import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	CanActivate,
	Router,
	CanActivateChild,
} from '@angular/router';
import { map, Observable, tap } from 'rxjs';

// --- Facades ---
import { AuthFacade } from '@facades/auth.facade';

// --- Interfaces ---
import { EUserProfileIds } from '@interfaces/user';

@Injectable({
	providedIn: 'root',
})
export class CustomerGuard implements CanActivate, CanActivateChild {
	private readonly isCustomer$ = this.authFacade.authState$.pipe(
		map(({ user }) => {
			return (
				user?.profileId === EUserProfileIds.CUSTOMER ||
				user?.profileId === EUserProfileIds.CUSTOMER_ADMIN
			);
		})
	);

	constructor(private _router: Router, private authFacade: AuthFacade) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return (this.isCustomer$ as Observable<boolean>).pipe(
			tap(isCustomer => !isCustomer && this._router.navigate(['/']))
		);
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.canActivate(route, state);
	}
}
